import type { ChecklistItem as BoardChecklistItem } from '../types/schema'

const toMarkdownTask = (node: BoardChecklistItem) =>
  `- [${node.isCompleted ? 'x' : ' '}] ${node.title}`

export const nodesToMarkdownPayload = (nodes: BoardChecklistItem[]) =>
  nodes.map(toMarkdownTask).join('\n')

export const parseMarkdownTaskPayload = (markdownPayload: string) =>
  markdownPayload
    .split(/\r?\n/g)
    .reduce<Array<{ title: string; isCompleted: boolean; description?: string }>>((tasks, line) => {
      const match = line.match(/^\s*[-*]\s+\[(x|X| )\]\s+(.+?)\s*$/)
      if (match) {
        tasks.push({
          title: match[2].trim(),
          isCompleted: match[1].toLowerCase() === 'x',
        })
        return tasks
      }

      const description = line.replace(/^\s{0,4}[-*]?\s*/, '').trim()
      const lastTask = tasks[tasks.length - 1]
      if (description && lastTask) {
        lastTask.description = lastTask.description
          ? `${lastTask.description}\n${description}`
          : description
      }
      return tasks
    }, [])
